import { MembershipMode } from 'utils/api/modules/memberGroups';

export const MEMBER_SEARCH_THRESHOLD = 10;

export interface MembershipModeLike {
  membershipMode: MembershipMode;
  active: boolean;
}

export const isDynamicGroup = (group: Pick<MembershipModeLike, 'membershipMode'>): boolean =>
  group.membershipMode === MembershipMode.Dynamic;

export const isManualGroup = (group: Pick<MembershipModeLike, 'membershipMode'>): boolean =>
  group.membershipMode === MembershipMode.Manual;

export const canManageMembers = (group: MembershipModeLike): boolean => group.active && isManualGroup(group);

export const canAddMembers = canManageMembers;
